import { ApplicationWithProject } from '../../../types/entities';
import { NAMES as ALL_APPLICATIONS_ACTIONS } from '../../actions/router/all-applications';
import { Action } from '../../redux.types';

export type AllApplicationsState = ApplicationWithProject[];

const defaultState: AllApplicationsState = [];

export const allApplications = (
  state: AllApplicationsState = defaultState,
  { type, payload }: Action,
): AllApplicationsState => {
  switch (type) {
    case ALL_APPLICATIONS_ACTIONS.ALL_APPLICATIONS_GET_SUCCESS:
      return payload;
    default:
      return state;
  }
};
